import { css } from "@emotion/react";

export const emptyHistoryStyle = css`
  font-size: 14px;
  font-weight: bold;
  padding-block: 80px;
  text-align: center;
`;
